import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

import { StaffRoleWithRoleProfileFragment } from '../../graphql/fragments/generated/StaffRoleWithRoleProfile';
import StaffRoleIcon from '../StaffRoleIcon';

function StaffRoleItem({ staffRole }: { staffRole: StaffRoleWithRoleProfileFragment }) {
  const { t } = useTranslation('StaffRoles');

  return (
    <Stack className="truncate">
      <Stack
        alignItems="center"
        className="h-48 w-48 rounded-full border border-divider bg-bg-primary"
        justifyContent="center">
        <StaffRoleIcon size={24} tagColor={staffRole?.metadata?.tagColor} />
      </Stack>
      <Stack className="truncate ms-16" direction="col" justifyContent="center">
        <Typography
          className="truncate"
          color="text-text-primary"
          data-testid="title"
          variant="body-short-01">
          {staffRole.name}
        </Typography>
        <Typography color="text-text-secondary" data-testid="memeber_count" variant="body-short-02">
          {t('Common:BulkExport.Member', { count: staffRole.roleProfile.usersCount })}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default StaffRoleItem;
